(function() {
  if (window.__dbQuickAddInit) return;
  window.__dbQuickAddInit = true;

  var activePicker = null;

  function setPickerState(picker, open) {
    if (!picker) return;
    picker.dataset.open = open ? 'true' : 'false';
    picker.setAttribute('aria-hidden', open ? 'false' : 'true');
    var toggle = document.querySelector('[aria-controls="' + picker.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) activePicker = picker;
    else if (activePicker === picker) activePicker = null;
  }

  function closeActive() { if (activePicker) setPickerState(activePicker, false); }

  function getCart() {
    return document.querySelector('cart-drawer, cart-notification, cart-items');
  }

  function addVariant(variantId, btnEl) {
    if (!variantId || btnEl.classList.contains('is-loading')) return;
    btnEl.classList.add('is-loading');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    var cart = getCart();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        var rawSections = cart.getSectionsToRender();
        if (Array.isArray(rawSections)) {
          var sections = rawSections.map(function(s) { return s.section; });
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }
      } catch (err) { /* non-fatal: proceed without section rendering */ }
      if (typeof cart.setActiveElement === 'function') {
        // Use the nearest persistent + button as the focus-restore target.
        // Falls back to the clicked button itself (still in DOM) to avoid
        // scrolling jumps when the drawer closes.
        var overlay = btnEl.closest('.db-qa-overlay, .db-qa, .product-card__actions');
        var focusTarget = overlay ? overlay.querySelector('.db-qa__btn') : null;
        cart.setActiveElement(focusTarget || btnEl);
      }
    }

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.errors || response.status) {
          console.error('Quick-add error:', response);
          return;
        }
        // On desktop, update cart sections without auto-opening the drawer.
        // On mobile, open the drawer so the user sees the add took effect.
        var isDesktop = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response, !isDesktop);
        }
        if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
        var picker = btnEl.closest('[data-db-qa-picker]');
        if (picker) setPickerState(picker, false);
        flashSuccess(btnEl);
      })
      .catch(function(err) { console.error(err); })
      .finally(function() { btnEl.classList.remove('is-loading'); });
  }

  // Briefly show a check on the + button to confirm add, and disable it to
  // prevent an accidental double-click.
  function flashSuccess(sourceEl) {
    var host = sourceEl.closest('.db-qa-overlay, .db-qa');
    var plusBtn = host ? host.querySelector('.db-qa__btn') : null;
    if (!plusBtn) return;
    plusBtn.classList.add('db-qa__btn--success');
    plusBtn.disabled = true;
    setTimeout(function() {
      plusBtn.classList.remove('db-qa__btn--success');
      plusBtn.disabled = false;
    }, 1200);
  }

  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-db-qa-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var picker = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!picker) return;
      if (activePicker && activePicker !== picker) setPickerState(activePicker, false);
      setPickerState(picker, picker.dataset.open !== 'true');
      return;
    }
    if (e.target.closest('[data-db-qa-close]')) {
      e.preventDefault();
      closeActive();
      return;
    }
    var size = e.target.closest('[data-db-qa-size]');
    if (size) {
      if (size.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      addVariant(size.getAttribute('data-variant-id'), size);
      return;
    }
    var single = e.target.closest('[data-db-qa-single]');
    if (single) {
      e.preventDefault();
      addVariant(single.getAttribute('data-variant-id'), single);
      return;
    }
    if (activePicker && !e.target.closest('[data-db-qa-picker]') && !e.target.closest('[data-db-qa-toggle]')) {
      closeActive();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeActive();
  });

  // Close picker after a small amount of scroll so it doesn't sit open as the user scrolls away.
  var scrollOpenY = null;
  window.addEventListener('scroll', function() {
    if (!activePicker) { scrollOpenY = null; return; }
    if (scrollOpenY === null) { scrollOpenY = window.scrollY; return; }
    if (Math.abs(window.scrollY - scrollOpenY) > 80) {
      closeActive();
      scrollOpenY = null;
    }
  }, { passive: true });
})();
